import iDot from "../../assets/images/100-circle-gray.svg";
import iPin from "../../assets/images/100-pin.svg";
import avatar4 from "../../assets/images/avatar2.png";

const NewComment = () => (
  <div className="fg-fs-comment-container">
    <section className="fg-fs-comments w-280">
      <div className="align-center">
        <img alt="" src={avatar4} width={24} height={24} className="m-r-8" />
        <div className="B2-SemiBold fg-text-white"> Add New Comment</div>
        <img alt="" src={iDot} width={4} height={4} className="m-lr-8" />
        <img alt="" src={iPin} width={12} height={12} className="m-r-2" />
        <div className="C1-Medium fg-text-gray-light"> 1:35</div>
      </div>
      <div className="B3-Regular fg-text-white p-t-6 p-b-4">
        <textarea
          className="fg dark-mode w-280"
          placeholder="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ev."
          rows="5"
        />
      </div>
      <div className="flex-end">
        <div className="button button-sm button-bk button-r m-r-5">Cancel</div>
        <div className="button button-sm button-dk button-r w-54">Send</div>
      </div>
    </section>
  </div>
);

export default NewComment;
